<div *ngIf="committeeMeeting" ngModelGroup="meetingMinutes" class="atlas-form mct-flex mct-col mct-gap-27">
  <h4>{{ 'committees.edit.committee-meetings.minutes.title' | translate | titlecase }}</h4>
  <span class="light-text">{{ 'committees.edit.committee-meetings.minutes.help-text' | translate | ucfirst }}</span>
  <div>
    <ng-container *ngIf="committeeMeeting.MeetingMinutesS3Key; else uploadButton">
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-27">
        <a target="_blank" (click)="downloadFile(fileDownloadLink, fileName)">{{ committeeMeeting.MeetingMinutesS3Key | s3Filename }}</a>
        <a class="delete-link" (click)="deleteFile()">
          <span *ngIf="!awaitingResponse">{{ 'common.delete' | translate | titlecase }}</span>
          <wl-busy *ngIf="awaitingResponse" [show]="true"></wl-busy>
        </a>
        <wl-ephemeral-content-swap #contentSwap>
          <a ngxClipboard [cbContent]="fileDownloadLinkForCopy" (click)="contentSwap.show()">
            {{ 'common.copy-url' | translate }}
          </a>
          <div class="wl-ephemeral-content">
            {{ 'common.copied-to-clipboard' | translate | ucfirst }}
          </div>
        </wl-ephemeral-content-swap>
      </div>
    </ng-container>
    <ng-template #uploadButton>
      <input #uploader type="file" hidden (change)="fileSelected($event)" />
      <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="awaitingResponse" (click)="uploader.click()">
        <span *ngIf="!awaitingResponse">{{ 'committees.edit.committee-meetings.minutes.upload-minutes' | translate | uppercase }}</span>
        <wl-busy *ngIf="awaitingResponse" [show]="true"></wl-busy>
      </button>
    </ng-template>
  </div>
  <div class="mct-flex mct-col">
    <label>{{ 'committees.edit.committee-meetings.minutes.simple-text-minutes' | translate | ucfirst }}</label>
    <textarea pInputTextarea name="simpleTextMinutes" [(ngModel)]="committeeMeeting.MeetingMinutes"></textarea>
  </div>
</div>
